import { render, staticRenderFns } from "./InventoryDetail.vue?vue&type=template&id=cd005bae&scoped=true&"
import script from "./InventoryDetail.vue?vue&type=script&lang=js&"
export * from "./InventoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./InventoryDetail.vue?vue&type=style&index=0&id=cd005bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd005bae",
  null
  
)

export default component.exports